import SearchModel from'./SearchModel';
class GunModel {
    id              = -1
    typeGun           = ""
    numberGun         = ""
    descGun            =""
    searchModel = null;
}

export default GunModel